module.exports = __webpack_public_path__ + "b63dd22c809e669ec252dcb61d5c0948.pdf";